module.exports = __webpack_public_path__ + "img/14.822fc6d6.jpg";